module.exports = __webpack_public_path__ + "img/ic-barchart-white.160c393d.svg";